import { render, staticRenderFns } from "./ticketSend.vue?vue&type=template&id=8ed0595c&"
import script from "./ticketSend.vue?vue&type=script&lang=js&"
export * from "./ticketSend.vue?vue&type=script&lang=js&"
import style0 from "./ticketSend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ed0595c')) {
      api.createRecord('8ed0595c', component.options)
    } else {
      api.reload('8ed0595c', component.options)
    }
    module.hot.accept("./ticketSend.vue?vue&type=template&id=8ed0595c&", function () {
      api.rerender('8ed0595c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/ticketManage/ticketSend/ticketSend.vue"
export default component.exports